import store from '../../../store'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const docStore = store();

docStore.registerModule('index', {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
})

export default docStore;



// WEBPACK FOOTER //
// ./app/resource/page/index/store/index.js